import { c as _c } from "react/compiler-runtime";
import { SplashScreen } from "@components/splash-screen/splash-screen";
import { splashScreenList } from "@components/splash-screen/splash-screen-data";
import { shouldShowSplashScreen } from "@components/splash-screen/splash-screen-utils";
import { runtimeConfig } from "@src/runtime-config";
import { RuntimeUtils } from "@stellar/utils";
import { selectedCompanyContextSelector, selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector, splashScreenTopicsByStatusSelector } from "@store/user/user-selector";
import { useMemo, useState } from "react";

/** Showing the appropriate splash screen topic to the user */
export function SplashScreenManager() {
  const $ = _c(14);
  const [isAnyScreenShownInSession, setIsAnyScreenShownInSession] = useState(false);
  const currentUser = useAppSelector(currentUserSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = splashScreenTopicsByStatusSelector("unseen");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const unseenSplashScreenTopics = useAppSelector(t0);
  const companyContextSelector = useAppSelector(selectedCompanyContextSelector);
  const selectedCompany = useAppSelector(selectedSdbCompanySelector);
  let t1;
  bb0: {
    if (currentUser === null || companyContextSelector?.userRoles.includes("user_role_fm_trial")) {
      t1 = null;
      break bb0;
    }
    let t2;
    if ($[1] !== companyContextSelector?.userRoles || $[2] !== currentUser || $[3] !== selectedCompany || $[4] !== unseenSplashScreenTopics) {
      let t3;
      if ($[6] !== companyContextSelector?.userRoles || $[7] !== currentUser || $[8] !== selectedCompany) {
        t3 = topic => shouldShowSplashScreen({
          topic,
          userRole: currentUser.role,
          company: selectedCompany,
          companyFeatures: companyContextSelector?.userRoles,
          currentDate: new Date().toISOString(),
          isProduction: RuntimeUtils.isProductionEnvironment(runtimeConfig.appEnv)
        });
        $[6] = companyContextSelector?.userRoles;
        $[7] = currentUser;
        $[8] = selectedCompany;
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      t2 = unseenSplashScreenTopics.filter(t3);
      $[1] = companyContextSelector?.userRoles;
      $[2] = currentUser;
      $[3] = selectedCompany;
      $[4] = unseenSplashScreenTopics;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const newSplashScreenTopics = t2;
    t1 = newSplashScreenTopics[0] ?? null;
  }
  const activeTopic = t1;
  if (activeTopic === null || isAnyScreenShownInSession) {
    return null;
  }
  const t2 = splashScreenList[activeTopic];
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsAnyScreenShownInSession(true);
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== activeTopic || $[12] !== t2) {
    t4 = <SplashScreen key={activeTopic} splashScreen={t2} onSplashScreenClosed={t3} />;
    $[11] = activeTopic;
    $[12] = t2;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}